<template>
	<div class="nk-tabs-component h-100" tabscope ref="tabs-component">
		<ul role="tablist" class="nk-tabs-items nav nav-tabs sticky-top" tabscope tabindex="1" ref="tabul">
			<li v-for="(tab, i) in tabs" :key="i" :id="tab.id" :class="{ 'is-active': tab.isActive, 'is-disabled': tab.isDisabled, 'is-sticky': tab.sticky, 'has-toolbar': tab.buttons && tab.buttons.length > 0 }" class="nk-tab nav-item" role="presentation" v-show="tab.isVisible" :tabindex="i + 1">
				<a v-if="!tab.sticky" @click="closeTab(tab.hash, $event)" class="nav-close"><i class="fal fa-times"></i></a>
				<a v-if="tab.sticky" class="nav-lock"><i class="fal fa-lock"></i></a>
				<a v-html="tab.header" :aria-controls="tab.hash" :aria-selected="tab.isActive ? true : null" @click="$event => selectTab(tab.hash, $event)" :href="tab.id" class="nk-tab-a nav-link" :class="{ 'active': tab.isActive, 'disabled': tab.isDisabled }" role="tab">
				</a>
			</li>
		</ul>
		<div class="nk-tabs-component-panels" ref="tabs-panel">
			<slot />
		</div>
		<context-menu :target="popperTarget">
			<menu-item v-for="menu in contextMenuItems" :key="menu.title" :title="menu.title" :handler="menu.handler" :shortcut="menu.shortcut"></menu-item>
		</context-menu>
	</div>
</template>
<script>
	import $ from 'jquery'
	import _, { subtract } from 'lodash'
	import TabOrder from '~/statics/taborder-functions'
	import $sc from '~/plugins/shortcut.collection.js'
	import dialog from '~/plugins/nikan-dialog-plugin'

	const trim = (str) => (str || '').replace(/^#(.+)$/i, '$1')

	export default {
		props: {
			options: {
				type: Object,
				required: false,
				default: () => ({
					useUrlFragment: true,
				}),
			},
			activeTab: undefined,
			closeConfirm: undefined,
			parentEl: {
				type: Function,
				default: () => { }
			}
		},
		emits: ['changed', 'removed', 'cleared'],

		data() {
			return {
				tabs: [],
				activeTabHash: '',
				contextMenuItems: [
					{
						title: this.$t('nav.tabs.cm.close'),
						handler: (item, e) => {
							e.preventDefault()

							if (this.currentTab) {
								this.closeTab(
									this.currentTab.hash,
									this.currentTab.isActive === true
								)
							}
						},
						shortcut: $sc.find('close-tab'),
					},
					{
						title: this.$t('nav.tabs.cm.close-other'),
						handler: (item, e) => {
							this.clearTabs(true)
						},
					},
					{
						title: this.$t('nav.tabs.cm.close-all'),
						handler: (item, e) => {
							this.clearTabs(false)
						},
					},
				],
			}
		},

		watch: {
			activeTab: {
				immediate: true,
				deep: true,
				handler: function (value, oldValue) {
					setTimeout(() => {
						if (value !== oldValue) {
							this.selectTab(value)
						}
					}, 1)
				},
			},
		},

		computed: {
			currentTab() {
				var cachedTabs = [...this.tabs].filter((x) => {
					return x.$options.name !== 'ContextMenu'
				})
				return _.head(cachedTabs.filter((x) => x.isActive === true))
			},
		},

		created() {
		},

		updated() {
			this.defer(this.subscribeKeys, 1)
		},

		mounted() {
			this.defer(this.subscribeKeys, 1)
			if (this.tabs.length) {
				this.selectTab(this.tabs[0].hash)
			}

			const middleClick = function (event) {
				if (event.which === 2 || event.button === 4) {
					event.preventDefault()

					let hash = $(event.target).attr('aria-controls')
					this.closeTab(hash, true)
				}
			}

			$(document).on('click', function (event) {
				if (event.which === 2 || event.button === 4) {
					event.preventDefault()
				}
			})
			$('.nk-tabs-items').on(
				'click auxclick',
				'.nk-tab-a',
				middleClick.bind(this)
			)
		},

		methods: {
			cacheHandler(tab, selectedTab) {

				// tab not allowed to be cached, therefore set isCached based on isActive
				if (!tab.cachable) {
					tab.isActive = tab.hash === selectedTab.hash
					tab.isCached = tab.isActive
					return tab
				}

				// tab is already cached, set isActive based on selectedTab
				if (tab.isCached) {
					tab.isActive = tab.hash === selectedTab.hash
					return tab
				}

				// tab is not cached but allowed to be cached, therefore cache the tab and set isActive based on selectedTab
				tab.isCached = true
				tab.isActive = tab.hash === selectedTab.hash
				tab.isCached = tab.isActive || tab.isCached
				return tab
			},
			findTab(hash) {
				return this.tabs.find((tab) => {
					return trim(tab.hash) === trim(hash)
				})
				// return _.head(
				// 	this.tabs.filter((tab) => {
				// 		return trim(tab.hash) === trim(hash)
				// 	})
				// )
			},
			selectTab(selectedTabHash, event) {
				// See if we should store the hash in the url fragment.
				if (event) {
					event.preventDefault()
				}

				const selectedTab = this.findTab(selectedTabHash)

				if (!selectedTab || selectedTab.isDisabled) {
					return
				}

				this.tabs.map((tab) => {
					tab = this.cacheHandler(tab, selectedTab)
				})

				this.activeTabHash = selectedTab.hash
				this.$emit('changed', { tab: selectedTab })

				setTimeout(() => {
					const currentTabEl = $(this.$refs['tabs-panel']).find('section:visible')
					if (currentTabEl.length > 0) {
						currentTabEl[0].focus()
						const startupEl = currentTabEl.find('[startup]:visible')
						if (startupEl.length > 0) {
							startupEl[0].focus()
						}
					}
				}, 50)
				this.$router.push({ name: 'page', params: { page: selectedTab.id, ...selectedTab.params }, query: { ...selectedTab.query, ...selectedTab.$props.query } })
			},
			setTabVisible(hash, visible) {
				const tab = this.findTab(hash)

				if (!tab) {
					return
				}

				tab.isVisible = visible

				if (tab.isActive) {
					// If tab is active, set a different one as active.
					tab.isActive = visible

					this.tabs.every((tab, index, array) => {
						if (tab.isVisible) {
							tab.isActive = true

							return false
						}

						return true
					})
				}
			},
			emitRemove(i) {
				this.$emit('removed', i)
			},
			closeTab(selectedTabHash, selectPrevTab) {
				const selectedTab = this.findTab(selectedTabHash)
				var newSelectedTab = null
				const remove = (tab, i) => {
					if (tab.isActive === true) {
						if (i > 0) {
							newSelectedTab = cachedTabs[i - 1]
						} else if (i === 0 && this.tabs.length > 1) {
							newSelectedTab = cachedTabs[i + 1]
						}
					}

					tab.isActive = false
					this.emitRemove(i)

					if (selectPrevTab && newSelectedTab != null) {
						// automatically change the tab
						this.selectTab(newSelectedTab.hash)
					}
					this.tabs.splice(i, 1)
				}

				if (!selectedTab || selectedTab.isDisabled || selectedTab.sticky) {
					return
				}

				var cachedTabs = [...this.tabs].filter((x) => {
					return x.$options.name !== 'ContextMenu'
				})
				const find = (tab) => {
					if (!this.$parent.$refs.tabContent || !this.$parent.$refs.tabContent.length)
						return null
					for (let tabContentRef of this.$parent.$refs.tabContent) {
						if ($(tabContentRef.$el).closest(`[id='${tab.hash}']`).length > 0)
							return tabContentRef
					}
					return null
				}
				for (var i = 0; i < cachedTabs.length; i++) {
					var tab = cachedTabs[i]

					if (trim(tab.hash) === trim(selectedTab.hash)) {
						let childClass = find(tab)
						var isClosable = tab.$slots.default()[0].props.closable
						if (childClass && isClosable && typeof childClass.isDataChanged === 'function') {
							childClass
								.isDataChanged()
								.then((isChanged) => {
									if (isChanged) {
										if (typeof childClass.changedFormAlert === 'function') {
											childClass.changedFormAlert((obj) => { remove(obj.tab, obj.i) }, { tab, i })
										} else
											dialog({
												title: this.$t('notifications.titles-attention'),
												body: this.$t('nav.tabs.unsaved-changed-data'),
												autoClose: true,
												buttons: [
													{
														title: this.$t('dialog.yes'),
														shortcut: $sc.find('yes', 'dialog'),
														isPrimary: true,
														handle: (button, page, e) => {
															remove(tab, i)
														},
													},
													{
														title: this.$t('dialog.cancel'),
														shortcut: $sc.find('cancel', 'dialog'),
														isCancel: true,
														handle: (button, page, e) => { },
													},
												],
											})
									} else {
										remove(tab, i)
									}
								})
								.catch((e) => {
									remove(tab, i)
								})
						} else {
							remove(tab, i)
						}
						break
					}

					//tab.isActive = false
				}
			},
			clearTabs(keepCurrent) {
				let _tabs = [...this.tabs].filter(
					(x) => !x.$options || x.$options.name !== 'ContextMenu'
				)
				let tabsToKeep = _tabs.filter(
					(x) =>
						x.sticky === true ||
						(keepCurrent && trim(x.hash) === trim(this.currentTab.hash))
				)
				this.$emit('cleared', tabsToKeep)

				if (tabsToKeep.length > 0) {
					let newSelectedTab = tabsToKeep[tabsToKeep.length - 1]
					this.selectTab(newSelectedTab.hash)

					for (var i = this.tabs.length - 1; i >= 0; i--) {
						if (tabsToKeep.findIndex((x) => x.id === this.tabs[i].id) === -1) {
							this.tabs.splice(i, 1)
						}
					}
				}
			},
			popperTarget() {
				let activeTabs = $('.nk-tabs-items .is-active')
				if (activeTabs.length > 0) {
					return activeTabs[0]
				} else {
					return $('.nk-tabs-items')[0]
				}
			},

			subscribeKeys() {
				// move handlers to the begining of the handlers
				this.$keyHandler.ReserveAt('tab-taborder-ctrl-enter-tabscope', 0)
				this.$keyHandler.ReserveAt('tab-taborder-previous', 0)
				this.$keyHandler.ReserveAt('tab-taborder-next', 0)

				TabOrder.subscribeKeys('tab', this)
				this.$keyHandler.Subscribe({
					name: `arrowLeft-button-asd65g`,
					// keyCode: 32, // 32:space
					// keyCode: 37, ctrlKey: true,altKey:false ,
					...$sc.find('ctrl-arrow-left'),
					el: this.parentEl(),
					context: this,
					handler: function (sender, e) {
						e.preventDefault()
						let findTab = this.tabs.findIndex(x => x.hash == this.activeTabHash)
						// console.log('this.activeTabHash',this.tabs)


						if (findTab + 1 <= this.tabs.length - 1) {
							// console.log('this.tabs[findTab+1]?.hash',this.tabs[findTab+2]?.hash)
							this.selectTab(this.tabs[findTab + 1]?.hash, e)
						} else {
							this.selectTab(this.tabs[0]?.hash, e)
						}

					},
				})
				this.$keyHandler.Subscribe({
					name: `arrowRight-button-asd65h`,
					// keyCode: 32, // 32:space
					// keyCode: 39,  ctrlKey:true ,
					...$sc.find('ctrl-arrow-right'),
					el: this.parentEl(),
					context: this,
					handler: function (sender, e) {
						e.preventDefault()
						let findTab = this.tabs.findIndex(x => x.hash == this.activeTabHash)

						if (findTab - 1 >= 0) {
							this.selectTab(this.tabs[findTab - 1]?.hash, e)
						} else {
							this.selectTab(this.tabs[this.tabs.length - 1]?.hash, e)
						}

					},
				})

				this.$keyHandler.Subscribe({
					name: `tab-open-close`,
					shortcut: this.contextMenuItems[0].shortcut,
					el: this.$refs['tabs-component'],
					context: this,
					handler: function (sender, e) {
						e.preventDefault()
						this.contextMenuItems[0].handler.call(this, {}, e)
					},
				})
			},
		},
	}
</script>

<style>
	.context-menu ul li .cm-item .cm-shortcut {
		color: #949494;
	}
</style>
